// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HeartOutlinedSvg from "@ant-design/icons-svg/es/asn/HeartOutlined";
import AntdIcon from '../components/AntdIcon';

var HeartOutlined = function HeartOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: HeartOutlinedSvg
  }));
};

HeartOutlined.displayName = 'HeartOutlined';
export default React.forwardRef(HeartOutlined);